<script setup lang="ts">
import Input from "~/components/UI/input.vue";
import type {InputField} from "~/constants/types/serviceInputs";

const props = defineProps<{
  field: InputField
}>();

if (isNaN( props.field.default_value)) {
  props.field.default_value = 0;
}
function validation(event:any){
  if(event.target.value>=props.field.validation_rules?.max){
    props.field.default_value=props.field.validation_rules?.max
  }
  if(event.target.value<props.field.validation_rules?.min??0 ){
    props.field.default_value=props.field.validation_rules?.min??0
  }
}

</script>

<template>
  <div class="flex flex-col rounded-xl gap-2">
    <p class="order-service-form-text">{{field.field_name}}</p>
    <input type="number"  v-model="props.field.default_value" @blur="validation" class="border border-gray-300 rounded-lg px-3 py-2"></input>
  </div>
</template>

<style scoped>

</style>